import type { TutorBillingRow } from '../model/interfaces'
import type { TutorBillingIndicator } from '../model/types'

import { TutorBillingChangeRequestStatus } from '@brighterly/lib-core-types/tutor/enums'

export const getTutorBillingIndicator = (row: TutorBillingRow): TutorBillingIndicator => {
  if (!row.has_salesforce_account) return 'new-account'
  if (row.change_request?.status === TutorBillingChangeRequestStatus.Pending) return 'change-pending'

  return null
}
